import { motion } from 'framer-motion'
import { useProjects } from '../hooks/useProjects'
import { GradientBackground } from './GradientBackground'

const allImages = [
  '/IMG/DUI/thumb.webp',
  '/IMG/DUI/thumb.png',
  '/IMG/DUI/THUMBNAIL.png',
  '/IMG/DUI/Screenshot 2026-01-04 085134.png',
  '/IMG/DUI/Screenshot 2026-01-04 085207.png',
  '/IMG/DUI/Screenshot 2026-01-04 085220.png',
  '/IMG/DUI/Screenshot 2026-01-04 085236.png',
  '/IMG/DUI/Screenshot 2026-01-04 085302.png',
  '/IMG/DUI/Screenshot 2026-01-04 085315.png',
  '/IMG/DUI/Screenshot 2026-01-04 085329.png',
  '/IMG/DUI/Screenshot 2026-01-04 085349.png',
  '/IMG/DUI/Screenshot 2026-01-04 085401.png',
]

export function ProjectDUI() {
  const { getRandomProject } = useProjects()
  
  const handleNextProject = () => {
    const randomProject = getRandomProject('dui-brand-system')
    if (randomProject) {
      window.location.hash = randomProject.slug
    }
  }
  
  return (
    <GradientBackground>
      {/* Hero Section - Cover image at 65% height, no text, natural brightness */}
      <section className="relative h-[65vh] w-full">
        <img 
          src="/IMG/DUI/thumb.webp" 
          alt="DUì Brand System"
          className="w-full h-full object-cover object-center"
        />
      </section>

      {/* Project Info */}
      <section className="py-20 px-4" style={{ background: 'linear-gradient(to bottom, transparent 0%, #CFCFCF 100%)' }}>
        <div className="container mx-auto max-w-4xl">
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16"
          >
            <div>
              <h3 className="text-sm uppercase tracking-wider text-white/60 mb-2">Client</h3>
              <p className="text-lg font-medium text-white">DUì</p>
            </div>
            <div>
              <h3 className="text-sm uppercase tracking-wider text-white/60 mb-2">Services</h3>
              <p className="text-lg font-medium text-white">Brand Identity, Art Direction</p>
            </div>
            <div>
              <h3 className="text-sm uppercase tracking-wider text-white/60 mb-2">Year</h3>
              <p className="text-lg font-medium text-white">2024</p>
            </div>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="prose prose-lg max-w-none"
          >
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-8">The Challenge</h2>
            <p className="text-xl text-white/80 leading-relaxed mb-12">
              DUì needed a comprehensive brand identity system that would capture the essence of their 
              innovative approach while standing out in a competitive market. The goal was to create 
              a flexible, memorable system that could adapt across all touchpoints.
            </p>

            {/* Images Grid - All images */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
              {allImages.map((src, index) => (
                <motion.img
                  key={src}
                  src={src}
                  alt={`DUì Project ${index + 1}`}
                  className="w-full rounded-lg shadow-lg"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.05 }}
                  loading="lazy"
                />
              ))}
            </div>

            <h2 className="text-3xl md:text-4xl font-bold text-white mb-8">The Solution</h2>
            <p className="text-xl text-white/80 leading-relaxed mb-12">
              We developed a brand system centered on a dynamic logo concept that adapts to different 
              contexts while maintaining brand recognition. The color palette combines vibrant tones 
              with neutral backgrounds for maximum flexibility.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Related Projects */}
      <section className="py-20 px-4" style={{ background: 'linear-gradient(to bottom, transparent 0%, #CFCFCF 100%)' }}>
        <div className="container mx-auto px-4">
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="/#works"
              className="group relative inline-flex items-center justify-center gap-2 px-8 py-4 text-white text-lg font-medium rounded-lg overflow-hidden cursor-pointer transition-transform duration-300 hover:scale-105" style={{ background: 'linear-gradient(90deg, #7ec876 0%, #4da6ff 50%, #7ec876 100%)', backgroundSize: '200% 100%', animation: 'gradient-shift 3s ease infinite' }}
            >
              ← Back to Works
            </a>
            <button 
              onClick={handleNextProject}
              className="group relative inline-flex items-center justify-center gap-2 px-8 py-4 text-white text-lg font-medium rounded-lg overflow-hidden cursor-pointer transition-transform duration-300 hover:scale-105" style={{ background: 'linear-gradient(90deg, #7ec876 0%, #4da6ff 50%, #7ec876 100%)', backgroundSize: '200% 100%', animation: 'gradient-shift 3s ease infinite' }}
            >
              Next Project →
            </button>
          </div>
        </div>
      </section>


    </GradientBackground>
  )
}
